/**
 * Az időjárás választott helyének TÁROLÁSA — a widget és a Beállítások →
 * Lokáció képernyő közös olvasó/író pontja (GRUNDO #61).
 *
 * Helye: `users/{uid}/private/settings.weatherPlace` — a tulajdonos maga
 * írja (`firestore.rules` → `private/{docId}`), nem játékadat. `null` = a
 * saját helyzet. Külön modul, mert a `weatherPlace.ts` tiszta, Firestore
 * nélkül tesztelt logika.
 */

import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '@/lib/firebase';
import { readPlaceChoice, type WeatherPlaceChoice } from '@/lib/weatherPlace';

export async function loadWeatherPlace(uid: string): Promise<WeatherPlaceChoice | null> {
  if (!db) return null;
  const snapshot = await getDoc(doc(db, 'users', uid, 'private', 'settings'));
  return readPlaceChoice(snapshot.data()?.weatherPlace);
}

export async function saveWeatherPlace(uid: string, choice: WeatherPlaceChoice | null): Promise<void> {
  if (!db) return;
  await setDoc(doc(db, 'users', uid, 'private', 'settings'), { weatherPlace: choice }, { merge: true });
}
